import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { SITE } from "@/data/site";

export const Story = () => {
  return (
    <section id="hikayemiz" className="beige-soft py-24 lg:py-32 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow inline-flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[hsl(var(--nl-champagne))]" />
            Hikâyemiz
            <span className="inline-block w-8 h-px bg-[hsl(var(--nl-champagne))]" />
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display text-4xl lg:text-6xl mt-5 text-[hsl(var(--nl-anthracite))]"
            data-testid="story-title"
          >
            {SITE.story.title}
          </motion.h2>
        </div>

        <div className="mt-20 relative">
          {/* timeline center line */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[hsl(var(--nl-champagne)/0.6)] to-transparent hidden md:block" />

          <div className="space-y-16 md:space-y-24">
            {SITE.story.chapters.map((c, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.8, delay: 0.05 * i }}
                  className="grid md:grid-cols-2 gap-8 md:gap-16 items-center relative"
                >
                  <div className={`md:order-${left ? 1 : 2} ${left ? "md:text-right" : ""}`}>
                    <span className="font-serif italic text-xl gold-text">0{i + 1}</span>
                    <h3 className="font-display text-2xl lg:text-3xl mt-2 text-[hsl(var(--nl-anthracite))]">
                      {c.heading}
                    </h3>
                    <div className={`gold-line mt-4 ${left ? "md:ml-auto" : ""}`} />
                  </div>
                  <div className={`md:order-${left ? 2 : 1} ${left ? "" : "md:text-right"}`}>
                    <p className="text-[15px] leading-[1.9] text-[hsl(var(--nl-anthracite))/0.8] max-w-md">
                      {c.text}
                    </p>
                  </div>

                  {/* node */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-[hsl(var(--nl-cream))] border border-[hsl(var(--nl-champagne))]" />
                </motion.div>
              );
            })}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-20 text-center max-w-2xl mx-auto"
        >
          <Sparkles className="mx-auto gold-text mb-5" size={20} />
          <p className="font-serif italic text-xl lg:text-2xl text-[hsl(var(--nl-anthracite))] leading-relaxed">
            “{SITE.story.closing}”
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
